import { DotContainer, Dot } from "./components/LoaderDotsContainer";

export interface LoaderDotsProps {
  size?: "small" | "medium" | "large" | "extraSmall";
  color?: "primary" | "secondary";
}

function LoaderDots(props: LoaderDotsProps) {
  const { size = "medium", color = "primary" } = props;

  return (
    <DotContainer size={size} data-testid="loader" color={color}>
      <Dot data-testid="loader-dot" data-loader="dot" />
      <Dot data-testid="loader-dot" data-loader="dot" />
      <Dot data-testid="loader-dot" data-loader="dot" />
    </DotContainer>
  );
}

export default LoaderDots;
